module.exports = __webpack_public_path__ + "static/05-248135ab1be4826c5353bdfc3f564c89.jpg";